import { CategoryType } from "../exercises.types";
import { ThemeModule } from "./theme.types";
import { AttentionSelectiveExercise } from "../pratiquer/Cognitif/AttentionSelectiveExercise";

export const attentionSelectiveTheme: ThemeModule = {
  id: "attention-selective",
  title: "Entrainer son attention selective",
  description:
    "Un theme pour s'exercer a reperer rapidement les bonnes informations et ignorer le bruit autour.",
  category: CategoryType.PRATIQUER,
  keywords: ["attention", "concentration", "cognitif"],
  pratiquerExercises: [AttentionSelectiveExercise],
  estimatedDuration: 10,
  level: "debutant",
  minAgeBand: "9-11",
  allowedRoles: ["enfant", "eleve", "parent", "enseignant"],
};
